import React from 'react';
import styled from 'styled-components';
import {
 CgClose
} from 'react-icons/cg';
import {
 LoaderSpinner
} from './LoaderSpinner';
import {
 Button
} from './ui/button';

const ModalBackground = styled.div`
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  position: fixed;
  display: flex;
  top: 0;
  left: 0;
  justify-content: center;
  z-index: 1000;
  overflow: hidden;
`;

const ModalContainer = styled.div`
  width: 450px;
  min-height: 200px;
  max-height: 220px;
  border-radius: 12px;
  background-color: hsl(var(--card));
  color: hsl(var(--foreground));
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  display: flex;
  flex-direction: column;
  margin-top: 5rem;
  padding: 20px;
`;

const CloseBtnContainer = styled.div`
  display: flex;
  justify-content: flex-end;
`;

const CloseBtn = styled.button`
  background-color: transparent;
  border: none;
  font-size: 20px;
  cursor: pointer;
  color: hsl(var(--foreground));
`;

const TitleContainer = styled.div`
  display: inline-block;
  text-align: center;
  margin-top: 10px;
  font-size: 20px;
`;

const MessageContainer = styled.div`
  margin-top: 10px;
  width: 100%;
  flex: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 13px;
  text-align: center;
`;

const BtnContainer = styled.div`
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  align-items: center;
  margin-top: auto;
`;

interface AlertModalProps {
  openModal: boolean;
  setopenModal: (value: boolean) => void;
  onDelete: () => void;
  btnTitle?: string;
  title?: React.ReactNode;
  subTitle?: React.ReactNode;
  loading?: boolean;
}

const AlertModal: React.FC<AlertModalProps> = ({
  openModal,
  setopenModal,
  onDelete,
  btnTitle = 'Permanently delete',
  title = 'Are you sure you want to delete this item?',
  subTitle = 'Once deleted, this item will no longer be accessible.',
  loading = false,
}) => {
  const handleCloseModal = (e: React.MouseEvent<HTMLDivElement | HTMLButtonElement>) => {
    if (loading) return;
    e.stopPropagation();
    setopenModal(false);
  };

  return (
      <>
          {openModal && (
          <ModalBackground className="cursor-default" onClick={handleCloseModal}>
              <ModalContainer onClick={(e) => e.stopPropagation()}>
                  <CloseBtnContainer>
                      <CloseBtn onClick={handleCloseModal}>
                          <CgClose size={20} />
                      </CloseBtn>
                  </CloseBtnContainer>

                  <TitleContainer>
                      <h3>{title}</h3>
                  </TitleContainer>

                  <MessageContainer>
                      <span>{subTitle}</span>
                  </MessageContainer>

                  <BtnContainer>
                      <Button variant="outline" onClick={handleCloseModal}>
                          Cancel
                      </Button>
                      <Button variant="destructive" className="w-[155px]" onClick={onDelete} disabled={loading}>
                          {loading ? <LoaderSpinner /> : btnTitle}
                      </Button>
                  </BtnContainer>
              </ModalContainer>
          </ModalBackground>
      )}
      </>
  );
};

export default AlertModal;